import React from "react";
import cx from "classnames";
import Image from "./GatsbyImage";

import "./Facts.css";
import { getImage } from "gatsby-plugin-image";

const Facts = ({ facts, lexicon }) => {
  if (!facts || facts.length === 0) return null;
  return (
    <section className="container pb-20 mx-auto cards">
      {lexicon.facts && (
        <h2 className="flex-1 cards-title title">{lexicon.facts}</h2>
      )}
      <div
        className={cx(
          "px-5 pb-5 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 lg:gap-5",
          {
            "mt-20 pt-5": !lexicon.facts,
          }
        )}
      >
        {facts.map(
          (
            {
              image: {
                description: alt,
                file: { fileLocal },
              },
              title,
              summary,
            },
            i
          ) => {
            const titleText = title.trim();
            return (
              <div
                key={i}
                className="card-wrapper"
                style={{ textShadow: "0 2px 4px rgba(0, 0, 0, 0.6)" }}
              >
                <div className="card">
                  <div className="card--front">
                    <Image
                      image={getImage(fileLocal)}
                      alt={alt}
                      className={cx({
                        "brightness-80": titleText,
                        "brightness-100": !titleText,
                      })}
                      aria-label={titleText}
                    />
                    {titleText && (
                      <span className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center px-2 text-xl font-bold leading-tight text-center text-white sm:text-2xl">
                        {titleText}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-center px-2 text-sm font-bold leading-tight text-center text-white card--back sm:text-2xl">
                    {summary}
                  </div>
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
};

export default Facts;
